"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementModels = void 0;
var ElementModels;
(function (ElementModels) {
    var AssetModel = /** @class */ (function () {
        /**
        * Represents Assets element
        * @constructor
        * @param {ElementContracts.IAssetContract} rawAsset - Raw asset contract
        */
        function AssetModel(contract) {
            this.contract = contract;
            this.name = contract.name;
            this.type = contract.type;
            this.size = contract.size,
                this.description = contract.description,
                this.url = contract.url;
            this.width = contract.width;
            this.height = contract.height;
        }
        return AssetModel;
    }());
    ElementModels.AssetModel = AssetModel;
    var MultipleChoiceOption = /** @class */ (function () {
        /**
        * Represents Kentico Kontent's multiple choice option
        * @constructor
        * @param {string} name - Name of the option
        * @param {string} codename - Codename of the option
        */
        function MultipleChoiceOption(name, codename) {
            this.name = name;
            this.codename = codename;
        }
        return MultipleChoiceOption;
    }());
    ElementModels.MultipleChoiceOption = MultipleChoiceOption;
    var TaxonomyTerm = /** @class */ (function () {
        /**
       * Represents taxonomy term
       * @constructor
       * @param {string} name - Name of the taxonomy option
       * @param {string} codename - Codename of the option
       */
        function TaxonomyTerm(name, codename) {
            this.name = name;
            this.codename = codename;
        }
        return TaxonomyTerm;
    }());
    ElementModels.TaxonomyTerm = TaxonomyTerm;
})(ElementModels = exports.ElementModels || (exports.ElementModels = {}));
//# sourceMappingURL=element-models.js.map